var map = {
	"./Documentation of stones Malachite.jpg": 45,
	"./Mapping volcano.jpg": 46,
	"./baba yaga.jpg": 47,
	"./beginning.jpg": 48,
	"./cave.JPG": 49,
	"./endless youth.jpg": 50,
	"./entrance.jpg": 51,
	"./falling star.jpg": 52,
	"./memory of volcano.jpg": 53,
	"./obsidian dream.jpg": 54,
	"./ritual.JPG": 55,
	"./sacred knowledge.jpg": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;